// TableHeader.jsx
import React, { Children } from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

const TableHeading = ({ className, label, sortedColumn, sortOrder, handleSort, children, columnId, labelClassName }: any) => {
    return (
        <th
            className={`ss-table-header-font ${className || ''}`}
            onClick={() => handleSort && handleSort(columnId)}
            style={handleSort ? { cursor: 'pointer' } : undefined}
        >
            <div className={`${labelClassName} table-arrow`}>
                {label}
                {handleSort && sortedColumn === columnId && (
                    <>
                        {sortOrder === 'desc' ? <FaArrowDown  className='ms-2'/> : <FaArrowUp className='ms-2' />}
                    </>
                )}
            </div>
            {children}
        </th>
    );
};

export default TableHeading;
